<template>
  <div>
    <div class="h-5"></div>
    <div class="flex flex-col gap-4">
      <div class="h-12 w-20 bg-gray-200 rounded-full dark:bg-gray-700"></div>
      <div class="h-4 w-44 bg-gray-200 rounded-full dark:bg-gray-700"></div>
      <div class="h-4 w-52 bg-gray-200 rounded-full dark:bg-gray-700"></div>
    </div>
  </div>
</template>